// import "./style.css";

import axios from "axios";
import { useState } from "react";
import { BsEnvelopeFill } from "react-icons/bs";
import { FaPhoneAlt } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import map from "../../images/spinsagacasino_map.png";
import Testimonials from "../Testimonials";

const HomeSubSection = () => {
  const [email, setEmail] = useState("");
  const [fullname, setFullname] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !fullname) {
      toast.error("Please fill out all fields.");
      return;
    }
    try {
      const response = await axios.post(
        "https://api-stage.spinsagacasino.com:5000/api/casino/casinosubscriber",
        {
          email: email,
          name: fullname,
        }
      );
      if (response.data.status == "success") {
        toast.success(response.data.message);
        setEmail("");
        setFullname("");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <ToastContainer position="bottom-center" limit={1} />


      <section className="sec-padd border-b no-cardp">
        <div className="container">
          <h2>Reasons to Join SpinSaga Today</h2>
          <p>
            <strong>Spin the Wheel of Fortune:</strong> Join SpinSaga and start
            with a bang! We welcome new players with a free coins bonus, letting
            you try your luck on our exciting games without spending a penny.
          </p>
          <p>
            <strong>Endless Gaming Variety:</strong> Dive into a world of
            possibilities! Explore our extensive slots library, classic table
            games, and immersive gaming experiences that put you right in the
            heart of the action.
          </p>

          <p>
            <strong>Unparalleled Customer Support:</strong> Our friendly and
            knowledgeable customer support team is here for you, 24/7. We're
            committed to providing a seamless and enjoyable gaming experience
            for all our players.
          </p>
          <p>
            <strong>Safety & Security Guaranteed:</strong> At SpinSaga, your
            safety and security are our top priorities. We utilize
            state-of-the-art encryption technology and adhere to the strictest
            industry standards to protect your information.
          </p>

          <div className="row g-md-5 g-4 pt-5">
            <div className="col-md-4">
              <div className="card1">
                <img
                  src={require("../../images/new-images/spinlogin.jpg")}
                  alt=""
                />
                <div className="card_name">
                  <p>
                    Unlock 30 days of Daily Bonuses! Get any Coin Pack and
                    receive 1 Saga Coin & 100 Gold Coins every day!
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card1">
                <img src={require("../../images/new-images/VIP.jpg")} alt="" />
                <div className="card_name">
                  <p>
                    Be part of the Elite VIP Club when you join SpinSaga. Enjoy
                    personalized promotions and exclusive bonuses!
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card1">
                <img
                  src={require("../../images/new-images/ReferaFreind.jpg")}
                  alt=""
                />
                <div className="card_name">
                  <p>
                    Refer your friends to SpinSaga and earn 5 Saga Coins each
                    time they join the fun – it’s a win-win!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <h2 className="c-heading">SpinSaga is available in</h2>
          <p className="sub-bold">
            You can now play in AL, AK, AZ, AR, CA, CO, CT, DE, FL, GA, HI, IL,
            IN, IA, KS, KY, LA, ME, MD, MA, MN, MS, MO, NH, NJ, NM, NY, NC, OH,
            OK, OR, PA, RI, SC, SD, TN, TX, UT, VT, VA, WV, WI, WY.
          </p>
          <div className="map_image" style={{ marginTop: "-30px" }}>
            <img src={map} />
          </div>
        </div>
      </section>

      <Testimonials />

      <section className="sec-padd top-sec">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-5 text-center">
              <h2 className="c-heading pb-4">Top Game of the Week</h2>
              <h4 className="sub-bold f-400 mb-4">Claim your Free Coins</h4>
              <p className="f-300">
                Our thriving social community is focused entirely on having fun,
                so why not join the SpinSaga party and start winning today?
              </p>
              <div className="pt-5">
                <a
                  href="https://play.spinsagacasino.com/signup"
                  className="btn btn-red"
                >
                  JOIN NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sec-padd border-b form-sec">
        <div className="container">
          <h2 className="c-heading">Get In Touch</h2>
          <p className="text-center pt-4">
            Have a question? Contact our support team today.
          </p>
          <p className="text-center pt-4">
            They are available to help you out 24/7 in case of any queries or
            technical issues.
          </p>
          <p className="text-center pt-4">
            <BsEnvelopeFill /> : support@spinsagacasino.com
          </p>
          <p className="text-center pt-4">
            <FaPhoneAlt /> : (844) 774-6724
          </p>
          <div className="row g-4 pt-5">
            <form onSubmit={handleSubmit}>
              <div className="col-md-8 m-auto">
                <div className="row g-4">
                  <div className="col-md-4">
                    <input
                      className="w-100"
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Email Address"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      className="w-100"
                      type="text"
                      name="fullName"
                      id="fullName"
                      placeholder="Full Name"
                      value={fullname}
                      onChange={(e) => {
                        setFullname(e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <input type="submit" value="Subscribe" />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};
export default HomeSubSection;
